import React from "react";
import LegalShell, { Section } from "@/components/LegalShell";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <LegalShell eyebrow="Trust" title="Privacy Policy" updated="7 February 2026">
        <Section title="Our promise">
          <p>
            Your family's privacy is not a feature we offer — it is a duty we
            carry. This policy explains, in plain language, what we collect,
            why, and the very short list of people who ever see it.
          </p>
        </Section>

        <Section title="1. Information we collect">
          <ul className="list-disc pl-5 space-y-2">
            <li><strong>Account details:</strong> name, email, phone, gender, and password (hashed with bcrypt — we never see it).</li>
            <li><strong>Dossier:</strong> the information you voluntarily share about yourself — deen, family, education, career, partner expectations.</li>
            <li><strong>Interactions:</strong> profiles you view, interests you send/accept, and messages you exchange (encrypted at rest).</li>
            <li><strong>Payment metadata:</strong> plan name, amount, timestamp, and payment reference. Card details are handled entirely by Razorpay; we never receive or store them.</li>
          </ul>
        </Section>

        <Section title="2. What we never do">
          <ul className="list-disc pl-5 space-y-2">
            <li>We never sell your data to advertisers or data brokers.</li>
            <li>We never share your profile with third-party matchmaking directories.</li>
            <li>We never reveal your contact details to another member without both families' explicit acceptance.</li>
            <li>We never send unsolicited marketing to invited family members.</li>
          </ul>
        </Section>

        <Section title="3. Who can see your profile">
          <p>
            Only active, hand-verified members of the opposite gender can view
            your dossier — and only after they have registered and their own
            profile has been reviewed. Contact information (email, phone) is
            gated behind an accepted interest or a paid membership.
          </p>
        </Section>

        <Section title="4. Cookies & sessions">
          <p>
            We use secure, HTTP-only cookies to keep you signed in. We do not
            place third-party advertising or tracking cookies on your device.
          </p>
        </Section>

        <Section title="5. Your rights">
          <p>
            You may request access to, correction of, or deletion of your data
            at any time by emailing <a className="text-brand-terracotta underline underline-offset-4" href="mailto:rashidhussain896@gmail.com">rashidhussain896@gmail.com</a>.
            We honour deletion requests within 30 days, except where retention
            is required by law (e.g. payment records).
          </p>
        </Section>

        <Section title="6. Contact for privacy matters">
          <p>Rashid Hussain · Data Controller · WR Rishtey<br />
            Email: <a className="text-brand-terracotta underline underline-offset-4" href="mailto:rashidhussain896@gmail.com">rashidhussain896@gmail.com</a><br />
            Phone: +91 98928 10623</p>
        </Section>
      </LegalShell>
    </div>
  );
}
